// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";

// English ships INSIDE the bundle. The site is prerendered in English and React
// hydrates over that markup, which only works if React's first render matches it.
// Loading English over HTTP meant the first render produced raw keys
// ("home.hero.title"), React discarded the prerendered DOM, and the page visibly
// rebuilt itself. Generated from public/locales/en/translation.json by
// scripts/bundle-en-locale.js — that file remains the source of truth.
import enTranslation from "./generated/enTranslation.json";

const I18N_VERSION = "20260717b";

i18n
    .use(HttpApi)                    // Load translations from /public/locales
    .use(LanguageDetector)           // Detect browser language
    .use(initReactI18next)           // Connect with React
    .init({
        supportedLngs: ["en", "ka", "es", "de"],
        fallbackLng: "en",
        debug: false,

        // Synchronous English, so the first render never shows keys.
        resources: { en: { translation: enTranslation } },
        // ...without stopping the backend below from fetching ka/es/de. A visitor
        // on one of those renders English first (matching the prerender, so
        // hydration succeeds), then their language swaps in as a normal update
        // rather than a wholesale DOM rebuild.
        partialBundledLanguages: true,

        react: {
            // No Suspense boundary exists around the router, and with English
            // already in memory there is nothing to suspend on.
            useSuspense: false,
        },

        detection: {
            order: ["localStorage", "navigator", "htmlTag"],
            caches: ["localStorage"],
        },

        backend: {
            // ?v= busts browser/CDN caches — bump I18N_VERSION whenever
            // translation.json files change, or stale caches serve old
            // files and new keys render as raw key names.
            loadPath: "/locales/{{lng}}/translation.json?v=" + I18N_VERSION,
        },
    });

export default i18n;
